import styled from "styled-components";

export const UploadFileNewStyled = styled.div`
  width: ${({ $width }) => $width || "100%"};

  .upload_file_new_inner {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
    width: 100%;

    &.theme_left_right {
      flex-direction: row;
    }
  }

  .theme_upload_set_image.upload_file_new_inner {
    margin: 0;
  }

  .box_upload {
    box-sizing: border-box;
    min-height: ${({ $heightBox }) => $heightBox || "200px"};
    height: ${({ $heightBox }) => $heightBox || "200px"};
    width: ${({ $width }) => $width || "100%"};
    border-radius: 8px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 16px;
    transition: border-color 0.15s ease;

    border: 2px dashed ${({ theme }) => theme.COLORS.GRAY_10};

    &.has_error {
      border: 2px dashed ${({ theme }) => theme.COLORS.RED_3};
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .upload_icon_wrap {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: ${({ $iconW }) => `${$iconW}px`};
        height: ${({ $iconH }) => `${$iconH}px`};
      }
    }

    .label_top {
      margin-top: 8px;
      text-align: center;
      font-family: ${({ theme, $fontTopFam }) =>
    $fontTopFam || theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme, $fontTopSize }) =>
    $fontTopSize || theme.FONT.SIZE.S12};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }

    .label_bottom {
      margin-top: 4px;
      text-align: center;
      font-family: ${({ theme, $fontBotFam }) =>
    $fontBotFam || theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme, $fontBotSize }) =>
    $fontBotSize || theme.FONT.SIZE.S12};
      color: ${({ theme }) => theme.COLORS.GRAY_4};
    }
  }

  .desc_text {
    margin-top: 8px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    line-height: 1.4;
  }

  .internal_error {
    margin-top: 8px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_3};
  }
`;

export const ShowImgBox = styled.div`
  box-sizing: border-box;
  position: relative;
  min-height: ${({ $heightBox }) => $heightBox || "200px"};
  height: ${({ $heightBox }) => $heightBox || "200px"};
  width: ${({ $width }) => $width || "100%"};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${({ $src }) => $src || ""});
  border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};

  &.has_error {
    border: 2px dashed ${({ theme }) => theme.COLORS.RED_3};
  }

  .remove_btn {
    position: absolute;
    right: 8px;
    top: 8px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    z-index: 2;
    line-height: 0;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;
